import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type { Dayjs } from 'dayjs';
import { not, or } from 'ember-truth-helpers';
import dateRangeDisplay from 'lumen/utils/dates/date-range-display';

interface GeneralDropdownsTriggersTriggerDateRangeSignature {
  Args: {
    extra?: {
      class?: string;
      isDisabled?: boolean;
      triggerLabelFormatter?: (start: Dayjs, end: Dayjs) => string;
    };
    isOpen: boolean;
    label?: string;
    selected: {
      end: Dayjs;
      start: Dayjs;
    };
    toggleDropdown: () => void;
  };
}

export default class GeneralDropdownsTriggersTriggerDateRange extends Component<GeneralDropdownsTriggersTriggerDateRangeSignature> {
  @service declare intl: Services['intl'];

  @action toggleDropdown(): void {
    if (this.args.extra?.isDisabled) {
      return;
    }

    this.args.toggleDropdown();
  }

  <template>
    {{! template-lint-disable require-presentational-children }}
    <div
      aria-disabled={{@extra.isDisabled}}
      class="select-wrapper left-column prism-dropdown-trigger picker month-selection-trigger
        {{if @isOpen 'open'}}
        {{if @label 'has-label'}}
        {{if @extra.isDisabled 'prism-dropdown-trigger--disabled'}}
        {{or @extra.class ''}}"
      data-event-id="datepicker-toggle-dropdown"
      data-event-value={{not @isOpen}}
      data-test-id="datepicker-toggle-dropdown"
      role="button"
      {{on "click" this.toggleDropdown}}
    >
      {{#if @label}}
        <div class="trigger-extra-label">
          {{@label}}
        </div>
      {{/if}}
      <div class="trigger__content gap-100">
        <span>
          {{#if @extra.triggerLabelFormatter}}
            {{@extra.triggerLabelFormatter @selected.start @selected.end}}
          {{else}}
            {{dateRangeDisplay @selected.start @selected.end this.intl}}
          {{/if}}
        </span>
        <PrismIcon
          @name={{if @isOpen "chevron-up" "chevron-down"}}
          @size="small"
        />
      </div>
    </div>
  </template>
}
